import { render, staticRenderFns } from "./OrderableActionProductResetPrice.vue?vue&type=template&id=7a681dcf&"
import script from "./OrderableActionProductResetPrice.vue?vue&type=script&lang=ts&"
export * from "./OrderableActionProductResetPrice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports